import styled from "styled-components";

type ContextBackgroundProps = {
    loading: boolean
}

export const ContextBackgroundBody = styled.div<ContextBackgroundProps>`
  
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  justify-content: center;
  align-items: center;
  background-color: rgba(0,0,0, 0);
  z-index: 800;
  display: ${({loading}) => loading ? 'flex': "none"};

`
